import ExcelJS from 'exceljs'

const EXCEL_CONTENT_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
const HEADER_FILL_COLOR = 'FF2C65AC'
const HEADER_FONT_COLOR = 'FFFFFFFF'
const BODY_FONT_COLOR = 'FF000000'
const EVEN_ROW_FILL_COLOR = 'FFFFFFFF'
const ODD_ROW_FILL_COLOR = 'FFE9F0FD'

const getNestedFieldValue = (item, field) => {
  const fieldParts = field.split('.')
  let value = item

  fieldParts.forEach(part => {
    if (value && typeof value === 'object' && part in value) {
      value = value[part]
    } else {
      value = undefined
    }
  })

  if (value === undefined || value === null || value === '') {
    return 'Không có'
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  return value
}

const applyWorksheetStyle = worksheet => {
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) {
      row.eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: HEADER_FILL_COLOR },
        }
        cell.font = {
          color: { argb: HEADER_FONT_COLOR },
          bold: true,
        }
      })
      return
    }

    const bgColor =
      rowNumber % 2 === 0 ? EVEN_ROW_FILL_COLOR : ODD_ROW_FILL_COLOR
    row.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: bgColor },
      }
      cell.font = {
        color: { argb: BODY_FONT_COLOR },
      }
    })
  })
}

export const exportContactsToExcel = async ({
  tableData,
  fileName,
  fieldsToExport,
  headers,
  columnWidths,
}) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Sheet 1')

  worksheet.columns = fieldsToExport.map((field, index) => ({
    header: headers[index] || field,
    key: field,
    width: columnWidths[index] || 10,
    style: {
      font: { name: 'Arial', color: { argb: HEADER_FONT_COLOR }, bold: true },
    },
  }))

  tableData.forEach(item => {
    const row = {}
    fieldsToExport.forEach(field => {
      row[field] = getNestedFieldValue(item, field)
    })
    worksheet.addRow(row)
  })

  applyWorksheetStyle(worksheet)

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: EXCEL_CONTENT_TYPE })
  const url = URL.createObjectURL(blob)
  const downloadLink = document.createElement('a')
  downloadLink.href = url
  downloadLink.download = fileName + '.xlsx'
  downloadLink.click()
  URL.revokeObjectURL(url)
}
